(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gita-ebook"] && !Shopify.designMode) return;
  try {
    
(function(){
function initialise(){
document.querySelectorAll('[data-gita-form]').forEach(function(form){
if(form.dataset.initialised)return;form.dataset.initialised='true';
var name=form.querySelector('[data-gita-name]'),email=form.querySelector('[data-gita-email]'),summary=form.querySelector('[data-gita-email-summary]'),button=form.querySelector('[data-gita-pay]'),message=form.querySelector('[data-gita-message]'),cartHelp=form.querySelector('[data-gita-cart-help]'),busy=false;
email.addEventListener('input',function(){summary.textContent=email.value.trim()||'Your email above';});
name.addEventListener('input',function(){name.setCustomValidity('');});
form.addEventListener('submit',async function(event){
event.preventDefault();if(busy)return;
name.value=name.value.trim();email.value=email.value.trim();
name.setCustomValidity(name.value?'':'Please enter your name.');if(!form.reportValidity())return;
message.hidden=true;cartHelp.hidden=true;
if(form.dataset.salesEnabled!=='true'){message.textContent='This eBook is not open for purchase yet. No payment has been taken.';message.hidden=false;return;}
busy=true;button.disabled=true;var originalText=button.textContent;button.textContent='Opening secure checkout…';
var properties={};new FormData(form).forEach(function(value,key){var match=key.match(/^properties\[(.*)\]$/);if(match)properties[match[1]]=String(value);});
var id=Number(form.querySelector('input[name="id"]').value),root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
try{
var cartResponse=await fetch(root+'cart.js',{credentials:'same-origin'});if(!cartResponse.ok)throw new Error('Unable to check the cart.');
var cart=await cartResponse.json();var existing=cart.items.some(function(item){return item.variant_id===id&&Object.keys(properties).every(function(key){return item.properties&&item.properties[key]===properties[key];});});
if(!existing){
var response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1,properties:properties}]})});
var result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'Unable to add the eBook. Please check your cart.');
}
window.location.assign(root+'checkout');
}catch(error){message.textContent=error.message||'Checkout could not open. Check your cart before trying again.';message.hidden=false;cartHelp.hidden=false;busy=false;button.disabled=false;button.textContent=originalText;}
});
});
}
initialise();document.addEventListener('shopify:section:load',initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
